/* MoRetro Studio V27 - Workshop orchestrator */
window.MTS = window.MTS || {};

(function(MTS){
  "use strict";

  async function start(){
    await MTS.WorkshopMachines.loadMachines();
    MTS.WorkshopConnector.startPolling();
    return MTS.WorkshopUI.render();
  }

  MTS.Workshop = {
    start,
    render: (...args)=>MTS.WorkshopUI.render(...args),
    loadMachines: (...args)=>MTS.WorkshopMachines.loadMachines(...args),
    saveMachine: (...args)=>MTS.WorkshopMachines.saveMachine(...args),
    testConnection: (...args)=>MTS.WorkshopUI.testConnection(...args),
    testViaStudio: (...args)=>MTS.WorkshopUI.testViaStudio(...args),
    printerList: (...args)=>MTS.WorkshopMachines.printerList(...args),
    activeProjects: (...args)=>MTS.WorkshopProduction.activeProjects(...args)
  };
})(window.MTS);
